import fileData from "@/data/file";
import inputData from "@/data/input";
import selectionsData from "@/data/selections";

const { batchNames: batchNamesSelectionKey } = selectionsData.keys;

const {
    assetsXml: assetsXmlFileName,
    metadataXml: metadataXmlFileName,
    takedown: takedownFileName,
    videoXml: videoXmlFileName,
    xml: xmlFileName,
} = fileData.names;

const { autoComplete: autoCompleteInputType, file: fileInputType, title: titleInputType } = inputData.types;

const { batchName: batchNameInputName, videoXmlDistributionFile: videoXmlDistributionFileInputName } = inputData.names;

const {
    assetsXml: assetsXmlInputLabel,
    batchName: batchNameInputLabel,
    metadataXml: metadataXmlInputLabel,
    takedown: takedownInputLabel,
    videoXml: videoXmlInputLabel,
    videoXmlDistributionFile: videoXmlDistributionFileInputLabel,
    xml: xmlInputLabel,
} = inputData.labels;

const clientXmlFileFormData = [
    {
        col: {
            md: 4,
            xs: 12,
        },
        isOptional: true,
        label: batchNameInputLabel,
        name: batchNameInputName,
        notTakeDownUI: true,
        selectionKey: batchNamesSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        isOptional: true,
        label: xmlInputLabel,
        name: xmlFileName,
        type: fileInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        hasOffset: true,
        isOptional: true,
        isTakeDownUI: true,
        label: takedownInputLabel,
        name: takedownFileName,
        type: fileInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        isOptional: true,
        isTakeDownUI: true,
        label: metadataXmlInputLabel,
        name: metadataXmlFileName,
        type: fileInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        isOptional: true,
        isTakeDownUI: true,
        label: assetsXmlInputLabel,
        name: assetsXmlFileName,
        type: fileInputType,
    },
    {
        col: {
            xs: 12,
        },
        isSpotifyOnly: true,
        label: videoXmlDistributionFileInputLabel,
        name: videoXmlDistributionFileInputName,
        type: titleInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        isOptional: true,
        isSpotifyOnly: true,
        label: videoXmlInputLabel,
        name: videoXmlFileName,
        type: fileInputType,
    },
];

export default clientXmlFileFormData;
